import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import "./theme.css"
import "react-toastify/dist/ReactToastify.css"
import "./toast.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { StyleReset, ThemeProvider as AtomizeThemeProvider } from "atomize"
import { theme } from "./settings/config"
import { Provider as StyletronProvider, DebugEngine } from "styletron-react"
import { Client as Styletron } from "styletron-engine-atomic"
import LessonsProvider from "./providers/lessons.provider"
import PlayersProvider from "./providers/players.provider"
import NotebookProvider from "./providers/notebook.provider"
import ModalProvider from "./providers/modal.provider"
import { ToastContainer } from "react-toastify"
import ProfileProvider from "./providers/profile.provider"
import { BrowserRouter } from "react-router-dom"
import SchoolProvider from "./providers/school.provider"
import SharedDataProvider from "./providers/sharedData.provider"
import ThemeProvider from "./providers/theme.provider"
import { registerServiceWorker } from "./serviceWorkerRegistration"
import { applySchemaSurface, readSchemaSurface } from "./lesson/schema/schemaSurface"
import CrashGuard from "./crash/CrashGuard"

const debug = process.env.NODE_ENV === "production" ? void 0 : new DebugEngine()

// L'app installata parte dalle lezioni (`start_url` in public/manifest.json).
// Chi l'ha messa sulla Home quando partiva da "/" la apre ancora lì finché il
// telefono non rilegge il manifest: all'apertura, e solo allora, "/" vuol
// dire lezioni. Si cambia l'indirizzo prima che React disegni qualcosa, così
// il sito non si vede nemmeno per un fotogramma. Dopo, "/" è il sito anche
// dentro l'app installata: ci porta "Guarda il sito" dall'accesso.
const isInstalledApp =
	window.matchMedia?.("(display-mode: standalone)").matches ||
	window.navigator.standalone === true
if (isInstalledApp && window.location.pathname === "/") {
	window.history.replaceState(window.history.state, "", `/lessons${window.location.search}`)
}

// La superficie degli schemi scelta nel profilo, da subito: un disegno che
// passa dal cemento alla terra mentre lo guardi sembrerebbe un errore.
applySchemaSurface(readSchemaSurface())

// 1. Create a client engine instance
const engine = new Styletron()

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
	<StyletronProvider value={engine} debug={debug} debugAfterHydration>
		<AtomizeThemeProvider theme={theme}>
			<StyleReset />
			<ThemeProvider>
				{/* se qualcosa si rompe mentre si disegna, una pagina al posto del
				    bianco (src/crash/CrashGuard.js): questa per i provider, e
				    quella intorno all'app, che sa chi è il maestro */}
				<CrashGuard>
					<BrowserRouter>
						{/* Profilo e circolo stanno sopra i cataloghi perché i
						    cataloghi hanno bisogno di sapere dove si è entrati: i
						    tipi di lezione che si vedono sono quelli globali più
						    quelli del circolo scelto, e li devono vedere uniti
						    tutti quelli che li leggono. */}
						<ProfileProvider>
							<SchoolProvider>
								<SharedDataProvider>
									<ModalProvider>
										<PlayersProvider>
											<NotebookProvider>
												<LessonsProvider>
													<CrashGuard>
														<App />
													</CrashGuard>
												</LessonsProvider>
											</NotebookProvider>
										</PlayersProvider>
									</ModalProvider>
								</SharedDataProvider>
							</SchoolProvider>
						</ProfileProvider>
					</BrowserRouter>
				</CrashGuard>

				<ToastContainer
					position="bottom-center"
					autoClose={6000}
					hideProgressBar
					newestOnTop
					closeOnClick={false}
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
			</ThemeProvider>
		</AtomizeThemeProvider>
	</StyletronProvider>
)

// Senza rete l'app si apre lo stesso, e le versioni nuove arrivano con un
// avviso invece che da sole: vedi serviceWorkerRegistration.js.
registerServiceWorker()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
